var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    focusable: "false",
    className: "chakra-icon css-nyt2fo",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: ":rgc:"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopOpacity: 0.2,
    stopColor: "currentColor"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#:rgc:)",
    d: "M8 1L6.32 6.48454H1L5.34 9.65979L3.66 15L8 11.6804L12.34 15L10.66 9.65979L15 6.48454H9.68L8 1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star-half.af35ae22f11fed0c12b1162acf4a40b3.svg";
export { ForwardRef as ReactComponent };